export default __webpack_public_path__ + "static/media/disney.f226955f.PNG";